export interface CurrentUser {
  id: string | null;
  role: string | null;
  email: string | null;
  name: string | null;
  department: string | null;
  raw: Record<string, any> | null;
}

const decodeTokenPayload = (): Record<string, any> | null => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const [, payload] = token.split('.');
    if (!payload) return null;

    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
    const decoded = window.atob(padded);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Error decoding current user token:', error);
    return null;
  }
};

export const getCurrentUser = (): CurrentUser => {
  const payload = decodeTokenPayload();
  if (!payload) {
    return { id: null, role: null, email: null, name: null, department: null, raw: null };
  }

  return {
    id: payload.userId || payload.id || payload.sub || null,
    role: payload.role || payload.userRole || null,
    email: payload.email || null,
    name: payload.name || payload.fullName || null,
    department: payload.department || null,
    raw: payload,
  };
};

export const getCurrentUserId = (): string | null => getCurrentUser().id;

export const getCurrentUserRole = (): string | null => getCurrentUser().role;

export const getCurrentUserDepartment = (): string | null => getCurrentUser().department;

export const isSuperAdmin = (): boolean => getCurrentUserRole() === 'SUPER_ADMIN';
